import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

export const hexAlpha = (hex, a) => {
  const h = (hex || "#64748B").replace("#", "");
  const n = parseInt(h.length === 3 ? h.split("").map((c) => c + c).join("") : h, 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${a})`;
};

export const statusStyle = (s) => (s ? { color: s.color, background: hexAlpha(s.color, 0.12), borderColor: hexAlpha(s.color, 0.35) } : {});

export function useStatuses() {
  const [statuses, setStatuses] = useState([]);
  const reload = () => api.get("/os-statuses").then((r) => setStatuses(r.data)).catch(() => {});
  useEffect(() => { reload(); }, []);
  const byName = useMemo(() => Object.fromEntries(statuses.map((s) => [s.name, s])), [statuses]);
  const active = useMemo(() => statuses.filter((s) => s.active), [statuses]);
  return { statuses, active, byName, reload, styleOf: (name) => statusStyle(byName[name]) };
}
